import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  @Output() change: EventEmitter<string> = new EventEmitter();
  constructor() { }

  changeImage = (img: string) => this.change.emit(img);
}
